
import Vue from 'vue'
import Component from 'vue-class-component';
import EventBus from './../../eventBus'
import {Watch,Mixins} from 'vue-property-decorator'
import UserProVisioning from '@/mixins/userProvisioning'
import CCIcon from '@/components/cc-icon/icon.vue';
import IconHelper from '../../mixins/iconHelper';

@Component ({
    components: {
        'cc-icon': CCIcon,
    },
})
export default class Container extends  Mixins(UserProVisioning, IconHelper){
    //Data
    budgetRoutes:Array<any> = [
        {
            caption:"Budget Lines",
            icon: 'bolt',
            link:"/budgeting-lines"
        },
        /*
        {
            caption:"Currencies",
            icon: 'dollar-sign',
            link:"/currencies"
        },
        */
        {
            caption:"Budget Templates",
            icon: 'file',
            link:"/budget-templates"
        },
        {
            caption:"Funding Tranche",
            icon: 'dollar-sign',
            link:"/fundings"
        }
    ]
    get  assetManagementRoutes(){
        let routes = [
        {
            caption:"Departments",
            icon: 'building',
            link:"/departments"
        },
        {
            caption:"Rigs",
            icon: this.rigsIcon(),
            link:"/rigs"
        },
        {
            caption:"Wells",
            icon: this.wellsIcon(),
            link:"/wells"
        },
        {
            caption:"Activities",
            icon: 'tasks',
            link:"/operations"
        }
    ]           	
    if(this.IsAdmin){
        routes.splice(0, 0, {
            caption:"Users",
            icon: 'users',
            link:"/users"
        })
    }
    return routes;
    }

     get settingsRoutes(){
        let routes = []
        if(this.canEditSettings){
            routes.push(
                {
                    caption:"App Settings",
                    icon: 'cog',
                    link:"/chart-settings"
                },
                {
                    caption:"Unit Settings",
                    icon: 'cog',
                    link:"/unit-settings"
                }
            );
        }
        if(this.IsAdmin){
            routes.push({
            caption:"Application Log",
            icon: 'list',
            link:"/application-log"
        });
        }
        return routes;
    }
    //computed
    get sidenav () {
        return this.$store.getters['getSideNavStatus']
    }

    get unreadNotifications (){
        return this.$store.getters["Notifications/getNumberOfUnreadNotifications"]
    }

    toggleSideNav(){
        this.$store.commit('setSideNav')
    }

    mounted(){
        this.$store.dispatch('settingsModule/getCompanyProfile')
        this.$store.dispatch('UnitsModule/getUnits')
        this.$store.dispatch('UnitsModule/getUnitSystem')
        this.$store.dispatch('settingsModule/getColorSettings')
        this.$store.dispatch('DailyReportModule/getAllReports')
        if(this.$store.getters["Notifications/isNotificationEmpty"])this.$store.dispatch("Notifications/getNotificaionsAction")
        if(this.$store.state.FileModule.files.length<1)this.$store.dispatch("FileModule/getFiles")
    }
}
